import OnePortalLogo from './OnePortalLogo';

export default OnePortalLogo;
